import React from 'react';
import './App.css';
import Header from './components/headerComp'
import Main from './components/mainComp';

function App() {
  return (
    <div className="App">
      <Header />
      <Main />
    </div>
  );
}

export default App;
